<nz-drawer
  [nzVisible]="visible()"
  nzPlacement="bottom"
  [nzHeight]="'auto'"
  [nzClosable]="false"
  nzWrapClassName="user-bottom-sheet-overlay"
  (nzOnClose)="onClose()">
  <ng-container *nzDrawerContent>
    <div class="user-bottom-sheet" [attr.data-cy]="dataCy()">
      <div class="user-bottom-sheet__handle" aria-hidden="true"></div>

      <div class="user-bottom-sheet__header">
        <lkt-avatar
          [src]="userAvatar()"
          [name]="userName()"
          size="small"
          shape="circle"
          [alt]="userName()">
        </lkt-avatar>
        <span class="user-bottom-sheet__greeting">Olá, {{ userName() }}!</span>
        <button
          type="button"
          class="user-bottom-sheet__close"
          aria-label="Fechar"
          data-cy="user-bottom-sheet-close"
          (click)="onClose()">
          <i class="uil uil-times"></i>
        </button>
      </div>

      <div class="user-bottom-sheet__profile" data-cy="user-bottom-sheet-profile">
        <span class="user-bottom-sheet__profile-label">Perfil de</span>
        <lkt-chip-component
          [label]="profileLabel()"
          [icon]="profileIcon()"
          chipSize="small"
          fontType="bold"
          [hasUserAction]="false">
        </lkt-chip-component>
        @if (hasMultipleProfiles()) {
          <button
            type="button"
            class="user-bottom-sheet__switch-profile"
            data-cy="user-bottom-sheet-switch-profile"
            (click)="onSwitchProfile()">
            Trocar de Perfil
          </button>
        }
      </div>

      <div class="user-bottom-sheet__list">
        @for (item of items(); track item.id) {
          <span
            class="user-bottom-sheet__item-anchor"
            [nzTooltipTitle]="item.disabled ? (item.disabledReason ?? null) : null"
            nz-tooltip>
            <button
              type="button"
              class="user-bottom-sheet__item"
              [class.user-bottom-sheet__item--disabled]="item.disabled"
              [disabled]="item.disabled"
              [attr.aria-disabled]="item.disabled ? 'true' : null"
              [attr.data-cy]="'user-bottom-sheet-item-' + item.id"
              (click)="onItemClick(item.id)">
              <div class="user-bottom-sheet__item-icon-wrapper">
                <i [class]="item.icon"></i>
              </div>
              <div class="user-bottom-sheet__item-text">
                <span class="user-bottom-sheet__item-title">{{ item.title }}</span>
                <span class="user-bottom-sheet__item-description">{{ item.description }}</span>
              </div>
              @if (item.control === "toggle") {
                <span
                  class="user-bottom-sheet__toggle"
                  [class.user-bottom-sheet__toggle--on]="item.checked"
                  role="switch"
                  [attr.aria-checked]="item.checked ? 'true' : 'false'"
                  [attr.data-cy]="'user-bottom-sheet-toggle-' + item.id">
                  <span class="user-bottom-sheet__toggle-knob"></span>
                </span>
              } @else if (item.showArrow !== false) {
                <i class="uil uil-angle-right user-bottom-sheet__item-arrow"></i>
              }
            </button>
          </span>
        }
      </div>

      <span class="user-bottom-sheet__version" data-cy="user-bottom-sheet-version">
        Lekto - Versão {{ version() }}
      </span>
    </div>
  </ng-container>
</nz-drawer>
